import React, { Component } from "react";
import {
  Button,
  Table,
  Alert,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import * as nguoiDungRoleConstant from './constants'
import * as nguoiDungRoleAction from './actions'
import { customSelectStyles } from '../../lib/common';
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';

class NguoiDungRole extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      listRole: [],
      listNguoiDung: [],
      keyword: '',
      selectedOption: null,
      RoleId: 0,
      formError: []
    };
  }
  handleSearchChange = (name, e) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.featchDetail()
    }
  }
  handleRoleChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({ RoleId: selectedOption.value }, () => {
      this.featchDetail();
    });
  };
  featchDetail = () => {
    const { nguoiDungRoleDetailRequest } = this.props
    var requestData = {
      keyword: this.state.keyword,
      StoreId: this.state.StoreId,
      RoleId: this.state.RoleId
    }
    return nguoiDungRoleDetailRequest(requestData);
  }
  fetchListRole = () => {
    const { nguoiDungRoleListRequest } = this.props
    var requestData = {
      stores_id: this.state.StoreId,
      keyword: this.state.keyword,
      status: this.state.TrangThaiId,
      page: 1,
      per_page: 200
    };
    return nguoiDungRoleListRequest(requestData);
  }
  filterListUser = (event) => {
    var updatedList = this.props.nguoiDungRole.resultNgDung;
    updatedList = updatedList.filter(function (item) {
      return (item.TenDayDu.toLowerCase().search(event.target.value.toLowerCase()) !== -1) || (item.username.toLowerCase().search(event.target.value.toLowerCase()) !== -1);
    });
    this.setState({ listNguoiDung: updatedList })
  }
  UpdateNguoiDung = (res, element) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.RoleId && this.state.RoleId > 0) {
      var requestData = {
        StoreId: this.state.StoreId,
        RoleId: this.state.RoleId || 0,
        UserIds: (res.UserId ? [res.UserId] : []),
        NguoiDungRoleIds: (res.NguoiDungRoleId ? [res.NguoiDungRoleId] : [])
      }
      this.props.nguoiDungRoleUpdateRequest(requestData);
    } else {
      formError.RoleId = "Bạn chưa chọn nhóm";
    }
    this.setState({ formError: formError });
  }
  UpdateAll = (res, flag) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.RoleId && this.state.RoleId > 0) {
      if(res && res.length > 0){
        var requestData = {
          StoreId: this.state.StoreId,
          RoleId: this.state.RoleId || 0,
          UserIds: (flag == "add" ? res.map(function(item) {return item.UserId}) : []),
          NguoiDungRoleIds: (flag == "remove" ? res.map(function(item) {return item.NguoiDungRoleId}) : [])
        }
        this.props.nguoiDungRoleUpdateRequest(requestData);
      }
    } else {
      formError.RoleId = "Bạn chưa chọn nhóm";
    }
    this.setState({ formError: formError });
  }
  processUpdateAllClick = (res, flag) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn cập nhật tất cả dữ liệu này không?
            </p>
            <button className="text-danger" onClick={() => {
              this.UpdateAll(res, flag)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  componentDidMount() {
    this.fetchListRole();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.nguoiDungRole.type == nguoiDungRoleConstant.NGUOIDUNG_ROLE_LIST_SUCCESS) {
      let { list } = nextProps.nguoiDungRole;
      this.setState({
        list: this.BuildSelectOption(list)
      });
    } else if (nextProps.nguoiDungRole.type == nguoiDungRoleConstant.NGUOIDUNG_ROLE_UPDATE_SUCCESS) {
      this.featchDetail();
    } else if (nextProps.nguoiDungRole.type == nguoiDungRoleConstant.NGUOIDUNG_ROLE_DETAIL_SUCCESS) {
      let { resultNgDung } = nextProps.nguoiDungRole;
      this.setState({ listNguoiDung: resultNgDung })
    }
  }
  BuildSelectOption(list) {
    var options = [];
    if (list && list.length > 0) {
      list.map((item) => { options.push({ value: item.RoleId, label: item.Name }) }
      );
    }
    return options;
  }
  render() {
    const { selectedOption, list, listNguoiDung } = this.state;
    const {
      handleSubmit,
      nguoiDungRole: {
        listRequesting,
        resultUser,
        resultNgDung
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="mb-3 border">
            <Select
              styles={customSelectStyles}
              placeholder="Chọn nhóm"
              value={selectedOption}
              onChange={this.handleRoleChange}
              options={list}
            />
            <em className="error invalid-feedback">{this.state.formError.RoleId}</em>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 row">
              <div className="col-sm-6">
                <Alert color="primary">Danh sách tài khoản chưa được thêm vào nhóm</Alert>
                <InputGroup>
                  <Input placeholder="Tên đăng nhập hoặc tên người dùng"
                    onChange={this.handleSearchChange.bind(this, "keyword")} 
                    onKeyDown={e => this.keyPress(e)}
                   />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" onClick={handleSubmit(this.featchDetail)}>
                      <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" className="text-left">Tài khoản đăng nhập</th>
                      <th scope="col" className="text-left">Tên người dùng</th>
                      <th scope="col" width="50" className="text-left">
                        <ButtonExt
                          btnClass="text-primary"
                          iconClass="fa-arrow-right fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(resultUser,"add")}
                          permission={BtnPermissions.NguoiDungRole.ADD_OR_UPDATE} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultUser && !!resultUser.length && (
                      resultUser.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-left">{res.username}</td>
                          <td className="text-left">{res.TenDayDu}</td>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-primary"
                              iconClass="fa-arrow-right fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateNguoiDung(res)}
                              permission={BtnPermissions.NguoiDungRole.ADD_OR_UPDATE} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
              <div className="col-sm-6">
                <Alert color="success">Danh sách tài khoản đã được thêm vào nhóm </Alert>
                <InputGroup>
                  <Input placeholder="Tên đăng nhập hoặc tên người dùng" onChange={this.filterListUser} />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" >
                      <i className="fa fa-search"></i> Tìm kiếm
                      </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50" className="text-center">
                        <ButtonExt
                          btnClass="text-danger"
                          iconClass="fa-arrow-left fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(listNguoiDung,"remove")}
                          permission={BtnPermissions.NguoiDungRole.ADD_OR_UPDATE} />
                      </th>
                      <th scope="col" className="text-left">Tài khoản đăng nhập</th>
                      <th scope="col" className="text-left">Tên người dùng</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listNguoiDung && !!listNguoiDung.length && (
                      listNguoiDung.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-center">
                            <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-arrow-left fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateNguoiDung(res)}
                              permission={BtnPermissions.NguoiDungRole.ADD_OR_UPDATE} />
                          </td>
                          <td className="text-left">{res.username}</td>
                          <td className="text-left">{res.TenDayDu}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nguoiDungRole: state.nguoiDungRole,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  nguoiDungRoleListRequest: nguoiDungRoleAction.nguoiDungRoleListRequest,
  nguoiDungRoleUpdateRequest: nguoiDungRoleAction.nguoiDungRoleUpdateRequest,
  nguoiDungRoleDetailRequest: nguoiDungRoleAction.nguoiDungRoleDetailRequest,
})(NguoiDungRole)
const formed = reduxForm({
  form: 'nguoiDungRole',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/NguoiDungRole/NguoiDungRole.js